import React from "react";
import { formatReferralCash, REFERRAL_UNLOCK_RULE_SHORT } from "../../utils/referralsHelpers";
import FirstDepositBonusCard from "./FirstDepositBonusCard";

const ReferralsStatusHero = ({
  rewardAmount,
  totals,
  firstDepositReward,
  claimingFirstDeposit,
  onClaimFirstDeposit,
}) => {
  const cards = [
    {
      id: "referred",
      label: "Referred",
      value: totals?.totalReferrals ?? 0,
    },
    {
      id: "qualified",
      label: "Qualified",
      value: totals?.rewardedCount ?? 0,
      tone: "success",
    },
    {
      id: "pending",
      label: "Pending",
      value: totals?.pendingCount ?? 0,
      hint: formatReferralCash(totals?.pendingCash ?? 0),
      tone: "pending",
    },
    {
      id: "received",
      label: "Cash received",
      value: formatReferralCash(totals?.earnedCash ?? 0),
      tone: "earned",
    },
  ];

  const cancelled = totals?.cancelledCount ?? 0;

  return (
    <section className="ref-hero" aria-label="Referrals">
      <div className="ref-hero-panel">
        <div className="ref-hero-head-copy">
          <p className="ref-hero-reward">
            {formatReferralCash(rewardAmount)} per friend · claim after they hit{" "}
            {REFERRAL_UNLOCK_RULE_SHORT}
          </p>
        </div>

        <FirstDepositBonusCard
          embedded
          reward={firstDepositReward}
          claiming={claimingFirstDeposit}
          onClaim={onClaimFirstDeposit}
        />

        <div className="ref-hero-stats-divider" aria-hidden />

        <div className="ref-hero-cards" aria-label="Referral totals">
          {cards.map((card) => (
            <div
              key={card.id}
              className={`ref-hero-card${card.tone ? ` ref-hero-card-${card.tone}` : ""}`}
            >
              <span className="ref-hero-card-label">{card.label}</span>
              {card.metrics ? (
                <div className="ref-hero-card-metrics">
                  {card.metrics.map((metric) => (
                    <div key={metric.label} className="ref-hero-card-metric">
                      <span className="ref-hero-card-metric-label">{metric.label}</span>
                      <strong className="ref-hero-card-metric-value tabular-nums">
                        {metric.value}
                      </strong>
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  <strong className="ref-hero-card-value tabular-nums">{card.value}</strong>
                  {card.hint ? (
                    <span className="ref-hero-card-hint tabular-nums">{card.hint}</span>
                  ) : null}
                </>
              )}
            </div>
          ))}
        </div>

        {cancelled > 0 ? (
          <p className="ref-hero-footnote tabular-nums">{cancelled} cancelled</p>
        ) : null}
      </div>
    </section>
  );
};

export default ReferralsStatusHero;
